import api from './api';
import type { User, PaginatedResponse, Role } from '../types';

interface ListUsersParams {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  role?: Role;
  search?: string;
}

interface CreateUserInput {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  role: Role;
  customerId?: string;
  partnerId?: string;
  ownerId?: string;
}

interface UpdateUserInput {
  email?: string;
  firstName?: string;
  lastName?: string;
  role?: Role;
  isActive?: boolean;
  customerId?: string | null;
  partnerId?: string | null;
  ownerId?: string | null;
}

export async function listUsers(params: ListUsersParams = {}): Promise<PaginatedResponse<User>> {
  const response = await api.get<PaginatedResponse<User>>('/users', { params });
  return response.data;
}

export async function getUser(id: string): Promise<User> {
  const response = await api.get<User>(`/users/${id}`);
  return response.data;
}

export async function createUser(data: CreateUserInput): Promise<User> {
  const response = await api.post<User>('/users', data);
  return response.data;
}

export async function updateUser(id: string, data: UpdateUserInput): Promise<User> {
  const response = await api.put<User>(`/users/${id}`, data);
  return response.data;
}

export async function deleteUser(id: string): Promise<void> {
  await api.delete(`/users/${id}`);
}

export async function resetUserPassword(id: string, password: string): Promise<void> {
  await api.put(`/users/${id}/reset-password`, { password });
}
